/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_All_Subscriptions_AutoInputs */

const en_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any subscriptions (including currently active subscriptions) will be automatically canceled, and will not be renewed at the next billing cycle. Any one-time, perpetual licenses you've purchased will continue to work as expected.`)
};

const id_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua langganan, termasuk langganan yang sedang aktif, akan dibatalkan secara otomatis, dan tidak akan diperbarui pada siklus penagihan berikutnya.`)
};

const ms_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebarang langganan, termasuk langganan yang sedang aktif, akan dibatalkan secara automatik, dan ia tidak akan diperbaharui pada kitaran bil yang seterusnya`)
};

const ca_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualsevol subscripció, incloses les subscripcions actualment actives, seran automàticament cancel·lades i no es renovaran en el seu pròxim cicle de facturació.`)
};

const cs_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechna předplatná, včetně aktuálně aktivních předplatných, budou automaticky zrušena a nebudou obnovena při dalším fakturačním období.`)
};

const da_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle abonnementer, inklusive aktuelt aktive abonnementer, vil automatisk blive annulleret og vil ikke blive fornyet ved deres næste faktureringscyklus`)
};

const de_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Abonnements (einschließlich derzeit aktiver Abonnements) werden automatisch gekündigt und im nächsten Abrechnungszyklus nicht mehr verlängert. Alle von Ihnen per einmaligem Kauf erworbenen unbefristeten Lizenzen behalten weiterhin ihre Gültigkeit.`)
};

const et_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kõik tellimused, sealhulgas praegu aktiivsed tellimused, tühistatakse automaatselt ja neid ei uuendata järgmisel arveldusperioodil`)
};

const es_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier suscripción, incluidas las suscripciones actualmente activas, se cancelará automáticamente y no se renovarán en su próximo ciclo de facturación`)
};

const fr_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les abonnements, y compris ceux actuellement actifs, seront automatiquement annulés et ne seront pas renouvelés au prochain cycle de facturation.`)
};

const hr_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sve pretplate, uključujući trenutačno aktivne pretplate, bit će automatski otkazane i neće biti obnovljene u sljedećem obračunskom ciklusu.`)
};

const it_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventuali abbonamenti, inclusi quelli attivi, verranno automaticamente annullati e non saranno rinnovati al successivo ciclo di fatturazione. Qualsiasi acquisto una tantum e le licenze perpetue acquistate continueranno a essere disponibili.`)
};

const lv_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi abonementi, tostarp pašreizējie aktīvie abonementi, tiks automātiski atcelti un tie netiks atjaunoti nākamajā norēķinu ciklā.`)
};

const lt_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visos prenumeratos, įskaitant šiuo metu aktyvias prenumeratas, bus automatiškai atšauktos ir nebus atnaujinamos kitame mokėjimo cikle`)
};

const hu_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden előfizetés, beleértve a jelenlegi aktív előfizetéseket is, automatikusan törlésre kerül, és nem kerül meghosszabbításra a következő számlázási ciklusban.`)
};

const nl_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle abonnementen, inclusief momenteel actieve abonnementen, worden automatisch geannuleerd en zullen niet worden verlengd in hun volgende factureringscyclus.`)
};

const nb_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle abonnementer, inkludert aktive abonnementer, sies opp automatisk og blir ikke fornyet i neste betalingsperiode`)
};

const pl_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie subskrypcje, w tym te obecnie aktywne, zostaną automatycznie anulowane i nie będą odnawiane w następnym cyklu rozliczeniowym`)
};

const pt_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer assinatura, incluindo assinaturas atualmente ativas, será automaticamente cancelada e não será renovada em seu próximo ciclo de faturamento. Qualquer licença permanente e perpétua que você tiver comprado continuará funcionado como esperado.`)
};

const ro_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orice abonamente, inclusiv abonamentele active în prezent, vor fi anulate automat și nu vor fi reînnoite la următorul ciclu de facturare.`)
};

const sk_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všetky predplatné, vrátane aktuálne aktívnych predplatných, budú automaticky zrušené a nebudú obnovené pri ich ďalšom fakturačnom cykle`)
};

const sl_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vse naročnine, vključno s trenutno aktivnimi naročninami, bodo samodejno preklicane in se ne bodo podaljšale v naslednjem obračunskem ciklu.`)
};

const fi_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tilaukset, mukaan lukien nykyiset aktiiviset tilaukset, peruutetaan automaattisesti, eikä niitä uusita seuraavassa laskutusjaksossa.`)
};

const sv_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla abonnemang, inklusive nuvarande aktiva abonnemang, kommer automatiskt att avbokas, och de kommer inte att förnyas vid nästa faktureringsperiod`)
};

const vi_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bất kỳ đăng ký nào, bao gồm các đăng ký đang hoạt động hiện tại, sẽ tự động bị hủy bỏ, và sẽ không được gia hạn trong chu kỳ thanh toán tiếp theo`)
};

const tr_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda aktif olan abonelikler dahil olmak üzere tüm abonelikler otomatik olarak iptal edilecek ve bir sonraki fatura döneminde yenilenmeyecektir.`)
};

const el_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οποιεσδήποτε συνδρομές, συμπεριλαμβανομένων των ενεργών συνδρομών, θα ακυρωθούν αυτόματα και δεν θα ανανεωθούν στον επόμενο κύκλο χρέωσής τους`)
};

const bg_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички абонаменти, включително текущо активни абонаменти, ще бъдат автоматично анулирани и няма да бъдат подновени за следващия им биллингов цикъл.`)
};

const ru_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Любые подписки, включая активные, будут автоматически отменены и не будут продлены в следующем расчетном периоде.`)
};

const sr_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Све претплате, укључујући тренутно активне претплате, биће аутоматски отказане и неће бити обновљене у следећем обрачунском периоду`)
};

const uk_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь-які підписки, включаючи поточно активні, будуть автоматично скасовані, і вони не будуть поновлені у наступному платіжному циклі.`)
};

const ka_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ყველა გამოწერა, მათ შორის ამჟამინდელი, ავტომატურად გაუქმდება და აღარ განახლდება მომდევნო საგადასახადო ციკლზე.`)
};

const hi_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी वर्तमान में सक्रिय सदस्यताओं सहित, किसी भी सदस्यता को स्वचालित रूप से रद्द कर दिया जाएगा, और उनकी अगली बिलिंग चक्र में नवीनीकृत नहीं किया जाएगा`)
};

const th_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสมัครทั้งหมด รวมถึงการสมัครที่กำลังใช้งานจะถูกยกเลิกโดยอัตโนมัติ และจะไม่ต่ออายุในรอบบิลถัดไป`)
};

const ko_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 활성화된 구독을 포함한 모든 구독이 자동으로 취소되며, 다음 청구 주기에 갱신되지 않습니다. 구매한 일회성 영구 라이선스는 모두 계속 정상 작동합니다.`)
};

const zh_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何订阅（包括当前有效的订阅）将会被自动取消，并且它们不会在下一个计费周期续订`)
};

const zh_tw_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任何訂閱服務（包括目前仍有效的訂閱）都將自動取消，且不會在下次計費週期自動續訂。您所購買的任何一次性永久授權，將繼續正常運作。`)
};

const ja_cancel_all_subscriptions_auto = /** @type {(inputs: Cancel_All_Subscriptions_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在有効なサブスクリプションを含むすべてのサブスクリプションが自動的にキャンセルされ、次の請求期間には更新されません。購入された1回限りの永久ライセンスは、そのまま継続して機能します。`)
};

/**
* | output |
* | --- |
* | "Any subscriptions (including currently active subscriptions) will be automatically canceled, and will not be renewed at the next billing cycle. Any one-time,..." |
*
* @param {Cancel_All_Subscriptions_AutoInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cancel_all_subscriptions_auto = /** @type {((inputs?: Cancel_All_Subscriptions_AutoInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_All_Subscriptions_AutoInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cancel_all_subscriptions_auto(inputs)
	if (locale === "ms") return ms_cancel_all_subscriptions_auto(inputs)
	if (locale === "ca") return ca_cancel_all_subscriptions_auto(inputs)
	if (locale === "cs") return cs_cancel_all_subscriptions_auto(inputs)
	if (locale === "da") return da_cancel_all_subscriptions_auto(inputs)
	if (locale === "de") return de_cancel_all_subscriptions_auto(inputs)
	if (locale === "et") return et_cancel_all_subscriptions_auto(inputs)
	if (locale === "es") return es_cancel_all_subscriptions_auto(inputs)
	if (locale === "fr") return fr_cancel_all_subscriptions_auto(inputs)
	if (locale === "hr") return hr_cancel_all_subscriptions_auto(inputs)
	if (locale === "it") return it_cancel_all_subscriptions_auto(inputs)
	if (locale === "lv") return lv_cancel_all_subscriptions_auto(inputs)
	if (locale === "lt") return lt_cancel_all_subscriptions_auto(inputs)
	if (locale === "hu") return hu_cancel_all_subscriptions_auto(inputs)
	if (locale === "nl") return nl_cancel_all_subscriptions_auto(inputs)
	if (locale === "nb") return nb_cancel_all_subscriptions_auto(inputs)
	if (locale === "pl") return pl_cancel_all_subscriptions_auto(inputs)
	if (locale === "pt") return pt_cancel_all_subscriptions_auto(inputs)
	if (locale === "ro") return ro_cancel_all_subscriptions_auto(inputs)
	if (locale === "sk") return sk_cancel_all_subscriptions_auto(inputs)
	if (locale === "sl") return sl_cancel_all_subscriptions_auto(inputs)
	if (locale === "fi") return fi_cancel_all_subscriptions_auto(inputs)
	if (locale === "sv") return sv_cancel_all_subscriptions_auto(inputs)
	if (locale === "vi") return vi_cancel_all_subscriptions_auto(inputs)
	if (locale === "tr") return tr_cancel_all_subscriptions_auto(inputs)
	if (locale === "el") return el_cancel_all_subscriptions_auto(inputs)
	if (locale === "bg") return bg_cancel_all_subscriptions_auto(inputs)
	if (locale === "ru") return ru_cancel_all_subscriptions_auto(inputs)
	if (locale === "sr") return sr_cancel_all_subscriptions_auto(inputs)
	if (locale === "uk") return uk_cancel_all_subscriptions_auto(inputs)
	if (locale === "ka") return ka_cancel_all_subscriptions_auto(inputs)
	if (locale === "hi") return hi_cancel_all_subscriptions_auto(inputs)
	if (locale === "th") return th_cancel_all_subscriptions_auto(inputs)
	if (locale === "ko") return ko_cancel_all_subscriptions_auto(inputs)
	if (locale === "zh") return zh_cancel_all_subscriptions_auto(inputs)
	if (locale === "zh-tw") return zh_tw_cancel_all_subscriptions_auto(inputs)
	if (locale === "ja") return ja_cancel_all_subscriptions_auto(inputs)
	return en_cancel_all_subscriptions_auto(inputs)
});